// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC4qIQlU7w1wkNQuWhJ0DFbY69-Etk3u90",
  authDomain: "testclooning.firebaseapp.com",
  databaseURL: "https://testclooning-default-rtdb.firebaseio.com",
  projectId: "testclooning",
  storageBucket: "testclooning.appspot.com",
  messagingSenderId: "958805430113",
  appId: "1:958805430113:web:a3da20b445e5f406b87f20",
  measurementId: "G-M5371STP6K",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
